export default "__VITE_ASSET__B76L1D60__"